import { Facebook, Instagram, Linkedin, Youtube, X } from "lucide-react"
import { unstable_cache } from "next/cache"
import { TelegramIcon, WhatsappIcon } from "react-share"

import SidebarHeader from "@/components/molecules/SidebarHeader"
import SocialLinks from "@/components/molecules/SocialLinks"
import { Tiktok } from "@/components/atoms/TiktokIcon"
import { getUser } from "@/actions/user/user.action"

export const platformIcons: Record<string, JSX.Element> = {
  facebook: <Facebook size={25} />,
  twitter: <X size={25} />,
  linkedin: <Linkedin size={25} />,
  instagram: <Instagram size={25} />,
  youtube: <Youtube size={25} />,
  tiktok: <Tiktok />,
  whatsapp: <WhatsappIcon size={25} />,
  telegram: <TelegramIcon size={25} />,
}

const getCachedAuthorInfo = unstable_cache(
  async (authorId: string) => {
    const res: any = await getUser(authorId)
    return res?.data?.data || {}
  },
  ["author-info"],
  { revalidate: 3600 }
)

export const SocialConnect = async ({ authorId, translations }: { authorId: string, translations: string }) => {
  try {
    const res = await getCachedAuthorInfo(authorId)
    const { social = [] } = res

    if (!social.length) return null

    const socialLinks = social
      .filter((s: { url: string; platform: string }) => !!platformIcons[s.platform])
      .map((s: { url: string; platform: string }) => ({
        href: s.url,
        label: s.platform,
        icon: platformIcons[s.platform],
      }))

    return (
      <div className="flex flex-col">
        <SidebarHeader title={translations} />
        <div className="py-5 flex justify-self-start">
          <SocialLinks links={socialLinks} spacing="small" buttonSize="icon" />
        </div>
      </div>
    )
  } catch (error) {
    return null
  }
}
